const allowedDomains = ['theknot.com', 'weddings.com'];

export function isValidRedirectUrl(url) {
	if (!url || typeof url !== 'string') {
		return false;
	}

	try {
		if (url.startsWith('/')) {
			return true;
		}

		const urlObj = new URL(url);

		return allowedDomains.some(
			(domain) =>
				urlObj.hostname === domain || urlObj.hostname.endsWith(`.${domain}`),
		);
	} catch (error) {
		console.error('Invalid URL:', error);
		return false;
	}
}
